import React from 'react'
import {Link} from 'react-router-dom'

class Header extends React.Component {
    constructor() {
        super()
        this.state = {
            showHeader: true,
            fadeHeader: 'light',
            openMenu: false
        }
    }

    componentDidMount() {
        let lastScrollTop = 0;
        window.addEventListener("scroll", (event) => {
            let st = window.pageYOffset || document.documentElement.scrollTop;
            const fadeHeader = (window.pageYOffset || document.documentElement.scrollTop) < 100 ? 'light' : 'dark';
            if (st > lastScrollTop) {
                this.setState({
                    showHeader: false,
                    fadeHeader
                })
            } else {
                this.setState({
                    showHeader: true,
                    fadeHeader
                })
            }
            lastScrollTop = st <= 0 ? 0 : st;
        }, false);
    }

    onClickMainMenu(nav, event) {
        event.preventDefault();
    }

    closeNav() {
        this.setState({
            openMenu: false
        })
    }

    openMenu() {
        this.setState({
            openMenu: !this.state.openMenu
        })
    }

    openChat(){
        collectchat.open('5ea7c08082d74543a6558281')
    }

    render() {
        return <div
            className={this.state.showHeader ? `header showHeader ${this.state.fadeHeader}` : `header hideHeader ${this.state.fadeHeader}`}>
            <div className={'header-sub'}>
                <ul className={'main-menu-header'}>
                    <li className={'logo header-list'}><Link to="/"></Link></li>
                    {/*
                    <li className={'header-list'} onClick={this.onClickMainMenu.bind(this,'product')}><Link to="/" activeClassName={'active'} className={'home'}>Home</Link></li>
*/}

                   {/* <li className={'header-list support'}>
                        Solutions
                        <ul className={'sub-menu'}>
                            <li><Link to="/solutions/sales/">Fit.Sales</Link></li>
                            <li><Link to="/solutions/employee-engagement">Employee Engagement</Link></li>
                            <li><Link to="/solutions/community-engagement">Community Engagement</Link></li>
                        </ul>
                    </li>*/}
                    <li className={'header-list case-studies'}>
                        <a href="https://www.hubbler.app/cases" target="_blank">Case Studies</a>
                    </li>
                    <li className={'header-list support'}>Support
                        <ul className={'sub-menu'}>
                            <li><Link to="/customerSupport">Customer Support</Link></li>
                            <li><a href="https://help.hubbler.mobi/faq/" target="_blank">FAQs</a></li>
                        </ul>
                    </li>
                    <li className={'header-list'}><Link to="/career"
                                                        activeClassName={'active'}>Careers <span>Hiring</span></Link>
                    </li>
                    <li className={'header-list blue-bt'}><a href="#"  onClick={this.openChat.bind(this)}>Get a demo</a></li>
                </ul>
                <div className={'mobile-menu'}>
                    <div className={this.state.openMenu ? 'dots open' : 'dots closed'}
                         onClick={this.openMenu.bind(this)}>
                        <div></div>
                        <div></div>
                    </div>
                    <div className={this.state.openMenu ? "sidenav open" : 'sidenav close'}
                         onClick={this.closeNav.bind(this)}>
                        <div className={'sidenav-sub'}>
                            <div><Link to="/solutions/sales/">Fit.Sales</Link></div>
                            <div><Link to="/solutions/employee-engagement">Employee Engagement</Link></div>
                            <div><Link to="/solutions/community-engagement">Community Engagement</Link></div>
                            <div><Link to={'/company/aboutus'}>About Us</Link></div>
                            <div><Link to={'/company/leadership-team'}>Leadership Team</Link></div>
                            <div><a href="#" onClick={this.openChat.bind(this)}>Contact Sales</a></div>
                            <div><Link to="/customerSupport">Customer Support</Link></div>
                            <div><a href="https://help.hubbler.mobi/faq/" target="_blank">FAQs</a></div>
                            <div><a href="https://www.hubbler.app/cases" target="_blank">Case Studies</a></div>
                            <div><Link to="/career">Career</Link></div>
                            <div><Link to="/contactUs">Contact Us</Link></div>
                            <div><Link to={'/privacypolicy'}>Privacy Policy</Link></div>
                            <div><Link to={'/termsofuse'}>Terms of Use</Link></div>
                        </div>
                    </div>
                </div>

                {/*<ul className={'login'}>
                    <li className={'header-list try-for-free'}><a href="https://lite1.eiris.in/web/Signup" target="_blank">Try for free</a></li>
                    <li className={'header-list login'}>Login</li>
                </ul>*/}
            </div>
        </div>
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js